import uniqid from 'uniqid';

export const getUniqueId = () => {
    // we wrap in case we want to switch to another library like we did from uuid
    return uniqid();
}
